export default {
  codes: [],
  documents: [],
  kontoart: [],
  countries: [],
  projektabschlussSelection: [],
  documentsProjektabschluss: []
}
